<template>
  <div class="align-center grid-x">
    <div class="align-middle grid-y">
      <div class="icon" :class="brand === 'mcom' ? 'bag-large-star' : 'bag-large'"></div>
      <p class="margin-top-xs large">
        {{ PURCHASE_HISTORY.noPurchasesAvailable }}
      </p>
      <p class="margin-bottom-s">
        {{ PURCHASE_HISTORY.noPurchasesAvailableSubHeading }}
      </p>
      <a href="/?linklocation=pagecontent" class="primary button expanded">
        {{ PURCHASE_HISTORY.startShopping }}
      </a>
    </div>
  </div>
</template>

<script setup>
import { brand, PURCHASE_HISTORY } from 'config';
</script>

<style lang="scss" scoped>
.icon {
  width: rem-calc(25);
  height: rem-calc(30);
  background-size: rem-calc(25 30);
}
</style>
<style lang="scss" brand="mcom" scoped>
@import '~@core/csg/src/scss/encodedIcons/mcom/_bag-large-star.scss';
</style>
<style lang="scss" brand="bcom" scoped>
@import '@core/csg/src/scss/encodedIcons/bcom/_bag-large.scss';
</style>
